import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	InputAdornment,
	MenuItem,
	TextField,
	Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import DeleteConfirmation from './DeleteConfirmation'
import React, { useEffect, useState, useMemo, useCallback } from 'react'
import { gray } from '../../utils/colors'


import MaskedInput from 'react-text-mask'

function TextMaskCustom(props) {
	const { inputRef, ...other } = props

	return (
		<MaskedInput
			{...other}
			ref={(ref) => {
				inputRef(ref ? ref.inputElement : null)
			}}
			mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
			placeholderChar={'\u2000'}
			showMask
		/>
	)
}



const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	},
	dialogTitle: {
		marginBottom: 24,
		fontSize: 16,
		textTransform: 'uppercase'
	},
	servicesWrapper: {
		marginBottom: '1.5rem'
	},
	serviceWrapper: {
		display: 'flex',
		alignItems: 'center',
		gap: '1rem',
		'& span': {
			width: '20%',
			fontSize: 12,
			letterSpacing: 0.75,
			textTransform: 'uppercase'
		}
	},
	contentWrapper: {
		display: 'flex',
		flexDirection: 'row',
		gap: '1.5rem',
		marginBottom: '4.25rem'
	},
	formWrapper: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: '1.25rem'
	},
	formColumnsWrapper: {
		flex: 1,
		display: 'flex',
		flexDirection: 'row',
		gap: '1.25rem'
	},
	formColumnWrapper: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: '1.25rem'
	},
	summaryWrapper: {
		backgroundColor: gray[200],
		flexBasis: '16rem',
		padding: '1.125rem',
		borderRadius: '0.375rem',
		'& h2': {
			fontSize: '1rem',
			color: gray[800]
		},
		display: 'flex',
		flexDirection: 'column',
		gap: '.5rem'
	},
	summaryTableWrapper: {
		flex: 1,
		display: 'flex',
		'& table': {
			width: '100%',
			color: gray[800],
			borderWidth: '1px',
			borderColor: gray[300],
			borderStyle: 'solid',
			borderLeftWidth: 0,
			borderRightWidth: 0,
			flex: 1,
			'& tr': {
				'& th': {
					fontWeight: 600,
					textAlign: 'left',
					fontSize: '0.75rem',
					textTransform: 'uppercase',
					padding: 0
				},
				'& td': {
					textAlign: 'left',
					fontSize: '0.875rem',
					padding: 0
				},
				'& th:first-child': {
					width: '55%'
				},
				'& td:first-child': {
					paddingRight: '2%'
				},
				'& th:last-child': {
					textAlign: 'right'
				},
				'& td:last-child': {
					textAlign: 'right'
				}
			}
		}
	},
	summaryTotalWrapper: {
		display: 'flex',
		fontSize: '1rem',
		'& div:first-child': {
			flex: 1
		}
	},
	fieldWrapper: {
		'& .MuiFilledInput-root': {
			minWidth: '100%'
		},
		'& .MuiTextField-root': {
			minWidth: '100%'
		}
	},
	disableButton: {
		color: '#D02C2C',
		fontSize: '14px',
		lineHeight: '19px',
		borderRadius: '25px',
		marginBottom: 32,
		'&:hover': {
			backgroundColor: 'rgba(208, 44, 44, 0.2)'
		}
	},
	close: {
		position: 'absolute',
		top: 10,
		right: 10,
		padding: 10,
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: 12,
		cursor: 'pointer'
	},
	datePicker: {
		margin: 0
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	calendarButton: {
		'& svg': {
			fill: '#777679'
		}
	}
}))

const blankGuard = {
    first_name: '',
    last_name: '',
    phone_number: ''
}

const AddGuardianDialog = (props) => {
	const classes = useStyles()
    const [guardian, setGuardian] = useState(blankGuard)
    const [isConfirmShown, setConfirmShown] = useState(false)

    const { first_name, last_name, phone_number } = guardian

	let { add, isShown, setIsShown } = props

    const update = (key, val) => {
        setGuardian({ ...guardian, [key]: val })
    }

	const save = () => {
        let guard = {
            ...guardian,
            phone_number: onlyNumbers(phone_number)
        }
        add(guard)
		setIsShown(false)
        setConfirmShown(false)
        setGuardian(blankGuard)
	}

    const onlyNumbers = (value) => {
		if (!value || value === '0') return value
		const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
		if (onlyNums.length) return onlyNums
		return ''
	}

    const filteredPhone = onlyNumbers(phone_number)


	return (
		<Dialog
			open={isShown}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}
			onClose={() => {
                setIsShown(false)
                setConfirmShown(false)
                setGuardian(blankGuard)
            }}
            PaperProps={{
                style: {
                    minWidth: 450,
                    maxWidth: 450
                }
            }}
			>
			<DialogTitle className={classes.dialogTitle}>ADD PET GUARDIAN</DialogTitle>
			<DialogContent>
				<div className={classes.contentWrapper}>
					<div className={classes.formWrapper}>
						<div className={classes.formColumnsWrapper}>
							<div className={classes.formColumnWrapper}>
                                <Typography variant="body2">Please ensure the phone number is correct. It will be used to verify the guardian’s identity during pick-up. </Typography>
								<div className={classes.fieldWrapper}>
                                    <Typography variant="overline">FIRST NAME</Typography>
									<TextField
										required
										label="First Name"
										variant="filled"
										value={guardian.first_name}
										onChange={(e) => update('first_name', e.target.value)}/>
										
								</div>
								<div className={classes.fieldWrapper}>
                                <Typography variant="overline">LAST NAME</Typography>
									<TextField
                                        required
										label="Last Name"
										variant="filled"
										value={guardian.last_name}
										onChange={(e) => update('last_name', e.target.value)}
										
									/>
								</div>
                                <div className={classes.fieldWrapper}>
                                <Typography variant="overline">PHONE NUMBER</Typography>
									<TextField
                                        required
										label="Phone Number"
										variant="filled"
										value={guardian.phone_number}
                                        InputProps={{
                                            inputComponent: TextMaskCustom
                                        }}
										onChange={(e) => update('phone_number', e.target.value)}
									/>
								</div>
							</div>
							
						</div>
					</div>
					
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="contained" color="secondary" onClick={() => setConfirmShown(true)} disabled={!first_name.length || !last_name.length || filteredPhone.length < 10}>
					SAVE
				</Button>
				<Button variant="outlined" color="secondary" onClick={() => {
                    setIsShown(false)
                    setGuardian(blankGuard)
                    setConfirmShown(false)
                }}>
					CANCEL
				</Button>
			</DialogActions>
            <DeleteConfirmation 
				isShown={isConfirmShown}
				onConfirmDelete={save}
				confirmButtonText="CONFIRM"
				title="Add Pet Guardian"
				body="Are you sure you want to add this person as a Pet Guardian? They will be allowed to pick up and drop-off this client’s pet(s) for appointments, but they will not be added as a Household Contact."
				setIsShown={setConfirmShown}/>
		</Dialog>
	)
}

export default AddGuardianDialog
